import { render, staticRenderFns } from "./sub-request-summary.vue?vue&type=template&id=79075244&scoped=true&"
import script from "./sub-request-summary.vue?vue&type=script&lang=js&"
export * from "./sub-request-summary.vue?vue&type=script&lang=js&"
import style0 from "./sub-request-summary.vue?vue&type=style&index=0&id=79075244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79075244",
  null
  
)

export default component.exports